module.exports = "<div class=\"background-component\" [ngStyle]=\"setBackground()\">\n  <ng-template #dynamicBgComponents></ng-template>\n</div>\n"